<template>
  <div>
    <span
      v-for="indicador in indicadores"
      :key="indicador.tipo"
      :class="clasesIndicador(indicador)"
      :data-toggle="tipoToggle(indicador)"
      :data-controller="tipoController(indicador)"
      :title="indicador.tooltip"
      :data-url="indicador.modal"
      data-modal-classes="modal-cifra-lg"
    >
      <i :class="clasesIcono(indicador)"></i>
    </span>
  </div>
</template>

<script>
import { dasherize } from '../../libs/strings';
import ComponentesJQuery from '../../mixins/cifra/ComponentesJQuery';

export default {
  mixins: [ComponentesJQuery],
  props: {
    indicadores: { type: Array, required: true },
  },
  updated() {
    // Cuando se actualice el componente (porque se le asignan los indicadores
    // asíncronamente), conectamos remote-modal
    // TODO: Hacer un componente como remote-modal pero sin jquery y que se pueda
    // usar con vanilla javascript desde cualquier parte
    this.loadJqueryComponents();
  },
  methods: {
    clasesIcono(indicador) {
      const nombre = dasherize(indicador.icono);
      let clases = `fa fa-${nombre} text-${indicador.color}`;
      if (indicador.modal) {
        clases = `${clases} clickable`;
      }
      return clases;
    },
    clasesIndicador(indicador) {
      let clases = 'indicador';
      if (indicador.modal) {
        clases = `${clases} clickable`;
      }
      return clases;
    },
    tipoToggle(indicador) {
      let res;
      if (indicador.tooltip) {
        res = 'tooltip';
      }
      return res;
    },
    tipoController(indicador) {
      let res;
      if (indicador.modal) {
        res = 'modal-remoto';
      }
      return res;
    },
  },
};
</script>

<style scoped>
  .indicador {
    margin-right: 4px;
  }
</style>
